import LOGO from "../images/Apaches.png";

export const Team__Apaches = {
  name: "Apaches",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#8B5E3C",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 52 + 33 + 32,
  goalsScoredAgainst: 49 + 54 + 49,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
